import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import type { Category } from '@klopotun/contracts';
import { categoryQueries } from '../queries/category-queries.js';
import { archiveCategory } from '../requests/archive-category.js';
import { restoreCategory } from '../requests/restore-category.js';

export type CategoryArchiveInput = { action: 'archive' | 'restore'; id: string };

const changeCategoryArchive = (input: CategoryArchiveInput): Promise<Category> => {
  if (input.action === 'archive') {
    return archiveCategory(input.id);
  }
  return restoreCategory(input.id);
};

/**
 * The default listing asks for unarchived categories only, so dropping the whole list branch is
 * what takes an archived category out of every picker on screen.
 */
export const useCategoryArchiveMutation = (): UseMutationResult<
  Category,
  Error,
  CategoryArchiveInput
> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: changeCategoryArchive,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: categoryQueries.lists() }),
  });
};
